import { defineComponent, reactive, toRefs, watch } from "vue";
import { Pie } from "vue-chartjs";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'

import { PieDataset } from "./interfaces/pie-dataset.interface";
import { PieProps } from "./interfaces/pie-props.interface";

ChartJS.register(ArcElement, Tooltip, Legend)

export default defineComponent({
    name: 'PieComponent',
    props: {
        labels: { type: Array as () => string[], required: true },
        datasets: { type: Array as () => PieDataset[], required: true },
        colors: { type: Array as () => string[] }
    },
    components: {
        Pie
    },
    setup(props: PieProps, { emit }) {
        const config = reactive({
            loaded: false,
            key: 0
        });

        const pieDataConfig = reactive({
            pieData: {
                labels: [] as string[],
                datasets: [] as PieDataset[],
            }
        });

        const pieOpts = reactive({
            responsive: true,
            maintainAspectRatio: false,
        });

        watch([() => props.labels, () => props.datasets], (
            [newLabels, newData], [oldLabels, oldData]
        ) => {
            if (newLabels != oldLabels) {
                pieDataConfig.pieData.labels = newLabels;
                pieDataConfig.pieData.datasets = newData;
                config.key++;
                config.loaded = true;
            }
        });

        return {
            ...toRefs(config),
            ...toRefs(pieDataConfig),
            pieOpts,
        }
    }
});